// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TabPotential_tab-potential__O1rgR {
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 8px 0 32px;
}
.TabPotential_tab-potential__intro__KL8Dn {
  max-width: 800px;
  margin-bottom: -16px;
}
.TabPotential_tab-potential__intro__KL8Dn p {
  color: var(--text-2, #6b7280);
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
}
.TabPotential_tab-potential__main-grid__qS6Pp {
  display: grid;
  grid-template-columns: 350px 1fr;
  gap: 32px;
  align-items: start;
}
@media (max-width: 1200px) {
  .TabPotential_tab-potential__main-grid__qS6Pp {
    grid-template-columns: 1fr;
  }
}
.TabPotential_tab-potential__left-col__QEezW {
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.TabPotential_tab-potential__right-col__uPM0T {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.TabPotential_kpi-row__-pHzb {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  border-top: 1px solid var(--light-grey, #e8e8e8);
  border-left: 1px solid var(--light-grey, #e8e8e8);
  margin-bottom: 8px;
}

.TabPotential_kpi-item__J4Ivj {
  background: transparent;
  padding: 18px 20px 16px;
  border-right: 1px solid var(--light-grey, #e8e8e8);
  border-bottom: 1px solid var(--light-grey, #e8e8e8);
  border-left: 2px solid transparent;
  display: flex;
  flex-direction: column;
  min-height: 88px;
  min-width: 0;
  transition: border-left-color 0.15s, background-color 0.15s;
}
.TabPotential_kpi-item__J4Ivj:hover {
  background: #f9f9f9;
  border-left-color: var(--explore-color, #0f3460);
}
.TabPotential_kpi-item__title__9pPzU {
  font-size: 11px;
  font-weight: 500;
  color: var(--text-2, #6b7280);
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  line-height: 1;
}
.TabPotential_kpi-item__value__059Id {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-variant-numeric: tabular-nums;
  font-size: 24px;
  font-weight: 400;
  color: var(--explore-color, #0f3460);
  line-height: 1.15;
  letter-spacing: -0.02em;
  flex: 1 1;
  min-width: 0;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.TabPotential_controls-bar__QKtRZ {
  background: transparent;
  border-top: 1px solid var(--light-grey, #e8e8e8);
  border-bottom: 1px solid var(--light-grey, #e8e8e8);
  padding: 24px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
}
.TabPotential_controls-bar__group__4IPMg {
  display: flex;
  align-items: center;
  gap: 12px;
}
.TabPotential_controls-bar__group__4IPMg label {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-1, #1a1a2e);
}

.TabPotential_signals__kqvyj {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-top: 1px solid var(--light-grey, #e8e8e8);
  border-left: 1px solid var(--light-grey, #e8e8e8);
}
@media (max-width: 900px) {
  .TabPotential_signals__kqvyj {
    grid-template-columns: 1fr;
  }
}

.TabPotential_signal-card__\\+Kjfn {
  background: transparent;
  padding: 24px;
  border-right: 1px solid var(--light-grey, #e8e8e8);
  border-bottom: 1px solid var(--light-grey, #e8e8e8);
}
.TabPotential_signal-card__title__oZYks {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-2, #6b7280);
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.TabPotential_signal-card__text__lACK1 {
  font-size: 13px;
  color: var(--text-1, #1a1a2e);
  margin: 0;
  line-height: 1.55;
}
.TabPotential_signal-card__text__lACK1 strong {
  color: var(--explore-color, #0f3460);
  font-weight: 600;
}

.TabPotential_view-controls__N93VR {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
}

.TabPotential_viewport__hl\\+XP {
  background: transparent;
  border: 1px solid var(--light-grey, #e8e8e8);
  min-height: 500px;
  display: flex;
  flex-direction: column;
}

.TabPotential_card__B7TBE {
  background: transparent;
  border: 1px solid var(--light-grey, #e8e8e8);
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
}
.TabPotential_card__header__f3z9U {
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.TabPotential_card__header__f3z9U h3 {
  font-size: 15px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--text-1, #1a1a2e);
  margin: 0;
}

.TabPotential_placeholder-box__K6uW\\+ {
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  color: var(--text-2, #6b7280);
  padding: 32px 0;
  min-height: 250px;
}

.TabPotential_drawer-header__l1TNo {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.TabPotential_drawer-header__main__mHA1K {
  display: flex;
  align-items: center;
  gap: 16px;
}
.TabPotential_drawer-header__avatar__xF3-s {
  width: 48px;
  height: 48px;
  background: #fafafa;
  border: 1px solid var(--light-grey, #e8e8e8);
  color: var(--explore-color, #0f3460);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}
.TabPotential_drawer-header__info__CqYLZ h2 {
  margin: 0 0 4px 0;
  font-size: 18px;
  font-weight: 500;
  color: var(--text-1, #1a1a2e);
}
.TabPotential_drawer-header__info__CqYLZ p {
  margin: 0;
  font-size: 13px;
  color: var(--text-2, #6b7280);
}

.TabPotential_compute-gate__z1qm0 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 56px 40px;
  max-width: 560px;
}
.TabPotential_compute-gate__eyebrow__1L\\+um {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #94a3b8;
  margin-bottom: 14px;
  font-family: system-ui, -apple-system, sans-serif;
}
.TabPotential_compute-gate__title__jFgnc {
  font-size: 22px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 12px 0;
  line-height: 1.35;
  font-family: system-ui, -apple-system, sans-serif;
}
.TabPotential_compute-gate__desc__h0BJr {
  font-size: 14px;
  color: #64748b;
  line-height: 1.65;
  margin: 0 0 28px 0;
  font-family: system-ui, -apple-system, sans-serif;
}
.TabPotential_compute-gate__pills__XvasV {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 32px;
}
.TabPotential_compute-gate__pill__sz\\+LX {
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  padding: 5px 12px;
  border-radius: 20px;
  font-family: system-ui, -apple-system, sans-serif;
  white-space: nowrap;
}
.TabPotential_compute-gate__filter-row__yMaxB {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 20px;
}
.TabPotential_compute-gate__filter-label__\\+lltT {
  font-size: 12px;
  color: #94a3b8;
  font-family: system-ui, -apple-system, sans-serif;
  margin-right: 2px;
}
.TabPotential_compute-gate__filter-tag__UT8I0 {
  font-size: 12px;
  font-weight: 500;
  color: #475569;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  padding: 2px 8px;
  border-radius: 4px;
  font-family: system-ui, -apple-system, sans-serif;
}
.TabPotential_compute-gate__btn__AdR-P {
  min-width: 160px;
  font-family: system-ui, -apple-system, sans-serif;
}

.TabPotential_needs-computation-state__Igs4W {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 32px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  text-align: center;
  margin: 32px auto;
  max-width: 600px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
}
.TabPotential_needs-computation-state__icon-wrapper__Q1sFn {
  width: 64px;
  height: 64px;
  border-radius: 32px;
  background: #ffffff;
  color: var(--explore-color, #0f3460);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  margin-bottom: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.TabPotential_needs-computation-state__Igs4W h2 {
  font-size: 22px;
  font-weight: 600;
  color: var(--explore-color, #0f3460);
  margin: 0 0 16px 0;
}
.TabPotential_needs-computation-state__Igs4W p {
  font-size: 15px;
  color: #475569;
  max-width: 480px;
  margin: 0 0 32px 0;
  line-height: 1.6;
}

.TabPotential_computing-state__9dSMj {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 32px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  text-align: center;
  margin: 32px auto;
  max-width: 600px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
}
.TabPotential_computing-state__icon__7V9R9 {
  font-size: 36px;
  color: var(--explore-color, #0f3460);
  margin-bottom: 24px;
}
.TabPotential_computing-state__9dSMj h2 {
  font-size: 20px;
  font-weight: 600;
  color: var(--explore-color, #0f3460);
  margin: 0 0 12px 0;
}
.TabPotential_computing-state__9dSMj p {
  font-size: 15px;
  color: #475569;
  margin: 0 0 40px 0;
}

.TabPotential_step-progress__pcXa\\+ {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
  max-width: 600px;
}
.TabPotential_step-progress__item__O8dgg {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  position: relative;
  flex: 1 1;
}
.TabPotential_step-progress__item__O8dgg::after {
  content: "";
  position: absolute;
  top: 16px;
  left: calc(50% + 24px);
  width: calc(100% - 48px);
  height: 2px;
  background: var(--light-grey, #e8e8e8);
  z-index: 0;
}
.TabPotential_step-progress__item__O8dgg:last-child::after {
  display: none;
}
.TabPotential_step-progress__icon__jGG2Y {
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background: #fff;
  border: 2px solid var(--light-grey, #e8e8e8);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: var(--text-3, #9ca3af);
  z-index: 1;
  transition: all 0.3s ease;
}
.TabPotential_step-progress__icon--active__71bNi {
  border-color: var(--explore-color, #0f3460);
  color: var(--explore-color, #0f3460);
  background: #eff6ff;
}
.TabPotential_step-progress__icon--done__vJzdI {
  background: var(--explore-color, #0f3460);
  border-color: var(--explore-color, #0f3460);
  color: #fff;
}
.TabPotential_step-progress__label__fzs9I {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-3, #9ca3af);
}
.TabPotential_step-progress__label--active__qu\\+xA {
  color: var(--text-1, #1a1a2e);
}

.TabPotential_data-status-row__de8VI {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  margin-bottom: 16px;
}
.TabPotential_data-status-row__left__nG6fC {
  display: flex;
  align-items: center;
  gap: 8px;
}
.TabPotential_data-status-row__dot__QrqRI {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #10b981;
  flex-shrink: 0;
}
.TabPotential_data-status-row__icon--spinning__Ufid1 {
  font-size: 14px;
  color: #3b82f6;
}
.TabPotential_data-status-row__text__5WEQj {
  font-size: 13px;
  color: #475569;
  font-family: system-ui, -apple-system, sans-serif;
  font-weight: 500;
}
.TabPotential_data-status-row__recompute__wy2Zc {
  font-size: 13px;
  font-weight: 500;
  color: #3b82f6;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-family: system-ui, -apple-system, sans-serif;
}
.TabPotential_data-status-row__recompute__wy2Zc:hover {
  color: #2563eb;
  text-decoration: underline;
}

.TabPotential_failed-state__\\+s5JW {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 32px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 12px;
  text-align: center;
  margin: 32px auto;
  max-width: 600px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
}
.TabPotential_failed-state__icon__Uh5Oy {
  font-size: 36px;
  color: #ef4444;
  margin-bottom: 24px;
  padding: 16px;
  background: #ffffff;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.TabPotential_failed-state__\\+s5JW h2 {
  font-size: 20px;
  font-weight: 600;
  color: #991b1b;
  margin: 0 0 12px 0;
}
.TabPotential_failed-state__\\+s5JW p {
  font-size: 15px;
  color: #b91c1c;
  max-width: 480px;
  margin: 0 0 32px 0;
  line-height: 1.6;
}

.TabPotential_skeleton-checking__IRCLi {
  padding: 40px;
  margin-top: 24px;
  border-radius: 12px;
  border: 1px solid var(--light-grey, #e8e8e8);
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}
.TabPotential_skeleton-checking__IRCLi .TabPotential_shimmer-text__hUOvT {
  height: 14px;
  width: 200px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: TabPotential_shimmer__lHeKB 1.5s infinite;
  border-radius: 4px;
}
.TabPotential_skeleton-checking__IRCLi .TabPotential_shimmer-box__Bx0Q1 {
  height: 200px;
  width: 100%;
  max-width: 600px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: TabPotential_shimmer__lHeKB 1.5s infinite;
  border-radius: 8px;
}

@keyframes TabPotential_shimmer__lHeKB {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/Collaborations/Tabs/Potential/TabPotential.module.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAAF;AAEE;EACE,gBAAA;EACA,oBAAA;AAAJ;AAEI;EACE,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AAAN;AAIE;EACE,aAAA;EACA,gCAAA;EACA,SAAA;EACA,kBAAA;AAFJ;AAII;EANF;IAOI,0BAAA;EADJ;AACF;AAIE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAFJ;AAKE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAHJ;;AAOA;EACE,aAAA;EACA,2DAAA;EACA,gDAAA;EACA,iDAAA;EACA,kBAAA;AAJF;;AAOA;EACE,uBAAA;EACA,uBAAA;EACA,kDAAA;EACA,mDAAA;EACA,kCAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,2DAAA;AAJF;AAME;EACE,mBAAA;EACA,gDAAA;AAJJ;AAOE;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AALJ;AAQE;EACE,+GAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,iBAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AANJ;;AAUA;EACE,uBAAA;EACA,gDAAA;EACA,mDAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;AAPF;AASE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAPJ;AASI;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;AAPN;;AAYA;EACE,aAAA;EACA,qCAAA;EACA,gDAAA;EACA,iDAAA;AATF;AAWE;EANF;IAOI,0BAAA;EARF;AACF;;AAWA;EACE,uBAAA;EACA,aAAA;EACA,kDAAA;EACA,mDAAA;AARF;AAWE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AATJ;AAYE;EACE,eAAA;EACA,6BAAA;EACA,SAAA;EACA,iBAAA;AAVJ;AAYI;EACE,oCAAA;EACA,gBAAA;AAVN;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAZF;;AAeA;EACE,uBAAA;EACA,4CAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AAZF;;AAeA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AAZF;AAcE;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAZJ;AAcI;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,6BAAA;EACA,SAAA;AAZN;;AAiBA;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,iBAAA;AAdF;;AAkBA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;AAfF;AAiBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAfJ;AAkBE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,4CAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAhBJ;AAoBI;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;AAlBN;AAqBI;EACE,SAAA;EACA,eAAA;EACA,6BAAA;AAnBN;;AAyBA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAtBF;AAwBE;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,iDAAA;AAtBJ;AAyBE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,iDAAA;AAvBJ;AA0BE;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,iDAAA;AAxBJ;AA2BE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AAzBJ;AA4BE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iDAAA;EACA,mBAAA;AA1BJ;AA6BE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AA3BJ;AA8BE;EACE,eAAA;EACA,cAAA;EACA,iDAAA;EACA,iBAAA;AA5BJ;AA+BE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iDAAA;AA7BJ;AAgCE;EACE,gBAAA;EACA,iDAAA;AA9BJ;;AAoCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kFAAA;AAjCF;AAmCE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,wCAAA;AAjCJ;AAoCE;EACE,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;AAlCJ;AAqCE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAnCJ;;AAuCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kFAAA;AApCF;AAsCE;EACE,eAAA;EACA,oCAAA;EACA,mBAAA;AApCJ;AAuCE;EACE,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;AArCJ;AAwCE;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AAtCJ;;AA0CA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;AAvCF;AAyCE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;AAvCJ;AAyCI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,wBAAA;EACA,WAAA;EACA,sCAAA;EACA,UAAA;AAvCN;AA0CI;EACE,aAAA;AAxCN;AA4CE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,4CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,6BAAA;EACA,UAAA;EACA,yBAAA;AA1CJ;AA4CI;EACE,2CAAA;EACA,oCAAA;EACA,mBAAA;AA1CN;AA6CI;EACE,yCAAA;EACA,2CAAA;EACA,WAAA;AA3CN;AA+CE;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;AA7CJ;AA+CI;EACE,6BAAA;AA7CN;;AAkDA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AA/CF;AAiDE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA/CJ;AAkDE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAhDJ;AAmDE;EACE,eAAA;EACA,cAAA;AAjDJ;AAoDE;EACE,eAAA;EACA,cAAA;EACA,iDAAA;EACA,gBAAA;AAlDJ;AAqDE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,iDAAA;AAnDJ;AAqDI;EACE,cAAA;EACA,0BAAA;AAnDN;;AAwDA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kFAAA;AArDF;AAuDE;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,wCAAA;AArDJ;AAwDE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAtDJ;AAyDE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAvDJ;;AA2DA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,4CAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAxDF;AA0DE;EACE,YAAA;EACA,YAAA;EACA,yEAAA;EACA,0BAAA;EACA,oDAAA;EACA,kBAAA;AAxDJ;AA2DE;EACE,aAAA;EACA,WAAA;EACA,gBAAA;EACA,yEAAA;EACA,0BAAA;EACA,oDAAA;EACA,kBAAA;AAzDJ;;AA6DA;EACE;IACE,2BAAA;EA1DF;EA6DA;IACE,4BAAA;EA3DF;AACF","sourcesContent":["// Doc-Ref: docs/features/collaborations-current.md\n.tab-potential {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  padding: 8px 0 32px;\n\n  &__intro {\n    max-width: 800px;\n    margin-bottom: -16px;\n\n    p {\n      color: var(--text-2, #6b7280);\n      font-size: 14px;\n      line-height: 1.6;\n      margin: 0;\n    }\n  }\n\n  &__main-grid {\n    display: grid;\n    grid-template-columns: 350px 1fr;\n    gap: 32px;\n    align-items: start;\n\n    @media (max-width: 1200px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  &__left-col {\n    display: flex;\n    flex-direction: column;\n    gap: 32px;\n  }\n\n  &__right-col {\n    display: flex;\n    flex-direction: column;\n    gap: 32px;\n  }\n}\n\n.kpi-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  border-top: 1px solid var(--light-grey, #e8e8e8);\n  border-left: 1px solid var(--light-grey, #e8e8e8);\n  margin-bottom: 8px;\n}\n\n.kpi-item {\n  background: transparent;\n  padding: 18px 20px 16px;\n  border-right: 1px solid var(--light-grey, #e8e8e8);\n  border-bottom: 1px solid var(--light-grey, #e8e8e8);\n  border-left: 2px solid transparent;\n  display: flex;\n  flex-direction: column;\n  min-height: 88px;\n  min-width: 0;\n  transition: border-left-color 0.15s, background-color 0.15s;\n\n  &:hover {\n    background: #f9f9f9;\n    border-left-color: var(--explore-color, #0f3460);\n  }\n\n  &__title {\n    font-size: 11px;\n    font-weight: 500;\n    color: var(--text-2, #6b7280);\n    margin-bottom: 8px;\n    text-transform: uppercase;\n    letter-spacing: 0.07em;\n    line-height: 1;\n  }\n\n  &__value {\n    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n    font-variant-numeric: tabular-nums;\n    font-size: 24px;\n    font-weight: 400;\n    color: var(--explore-color, #0f3460);\n    line-height: 1.15;\n    letter-spacing: -0.02em;\n    flex: 1;\n    min-width: 0;\n    width: 100%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.controls-bar {\n  background: transparent;\n  border-top: 1px solid var(--light-grey, #e8e8e8);\n  border-bottom: 1px solid var(--light-grey, #e8e8e8);\n  padding: 24px 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 16px;\n\n  &__group {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n\n    label {\n      font-size: 13px;\n      font-weight: 500;\n      color: var(--text-1, #1a1a2e);\n    }\n  }\n}\n\n.signals {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  border-top: 1px solid var(--light-grey, #e8e8e8);\n  border-left: 1px solid var(--light-grey, #e8e8e8);\n\n  @media (max-width: 900px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.signal-card {\n  background: transparent;\n  padding: 24px;\n  border-right: 1px solid var(--light-grey, #e8e8e8);\n  border-bottom: 1px solid var(--light-grey, #e8e8e8);\n  // No side-stripe — that's the 2018-SaaS-AI anti-pattern.\n\n  &__title {\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: var(--text-2, #6b7280);\n    margin-bottom: 8px;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n  }\n\n  &__text {\n    font-size: 13px;\n    color: var(--text-1, #1a1a2e);\n    margin: 0;\n    line-height: 1.55;\n\n    strong {\n      color: var(--explore-color, #0f3460);\n      font-weight: 600;\n    }\n  }\n}\n\n.view-controls {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 16px;\n}\n\n.viewport {\n  background: transparent;\n  border: 1px solid var(--light-grey, #e8e8e8);\n  min-height: 500px;\n  display: flex;\n  flex-direction: column;\n}\n\n.card {\n  background: transparent;\n  border: 1px solid var(--light-grey, #e8e8e8);\n  padding: 32px 24px;\n  display: flex;\n  flex-direction: column;\n\n  &__header {\n    margin-bottom: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    h3 {\n      font-size: 15px;\n      font-weight: 600;\n      text-transform: uppercase;\n      letter-spacing: 0.03em;\n      color: var(--text-1, #1a1a2e);\n      margin: 0;\n    }\n  }\n}\n\n.placeholder-box {\n  background: transparent;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  text-align: left;\n  color: var(--text-2, #6b7280);\n  padding: 32px 0;\n  min-height: 250px;\n}\n\n// Drawer Header\n.drawer-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n\n  &__main {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n  }\n\n  &__avatar {\n    width: 48px;\n    height: 48px;\n    background: #fafafa;\n    border: 1px solid var(--light-grey, #e8e8e8);\n    color: var(--explore-color, #0f3460);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 24px;\n  }\n\n  &__info {\n    h2 {\n      margin: 0 0 4px 0;\n      font-size: 18px;\n      font-weight: 500;\n      color: var(--text-1, #1a1a2e);\n    }\n\n    p {\n      margin: 0;\n      font-size: 13px;\n      color: var(--text-2, #6b7280);\n    }\n  }\n}\n\n// Compute Gate\n.compute-gate {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 56px 40px;\n  max-width: 560px;\n\n  &__eyebrow {\n    display: inline-block;\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    color: #94a3b8;\n    margin-bottom: 14px;\n    font-family: system-ui, -apple-system, sans-serif;\n  }\n\n  &__title {\n    font-size: 22px;\n    font-weight: 600;\n    color: #1e293b;\n    margin: 0 0 12px 0;\n    line-height: 1.35;\n    font-family: system-ui, -apple-system, sans-serif;\n  }\n\n  &__desc {\n    font-size: 14px;\n    color: #64748b;\n    line-height: 1.65;\n    margin: 0 0 28px 0;\n    font-family: system-ui, -apple-system, sans-serif;\n  }\n\n  &__pills {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-bottom: 32px;\n  }\n\n  &__pill {\n    font-size: 12px;\n    font-weight: 500;\n    color: #374151;\n    background: #f1f5f9;\n    border: 1px solid #e2e8f0;\n    padding: 5px 12px;\n    border-radius: 20px;\n    font-family: system-ui, -apple-system, sans-serif;\n    white-space: nowrap;\n  }\n\n  &__filter-row {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin-bottom: 20px;\n  }\n\n  &__filter-label {\n    font-size: 12px;\n    color: #94a3b8;\n    font-family: system-ui, -apple-system, sans-serif;\n    margin-right: 2px;\n  }\n\n  &__filter-tag {\n    font-size: 12px;\n    font-weight: 500;\n    color: #475569;\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    padding: 2px 8px;\n    border-radius: 4px;\n    font-family: system-ui, -apple-system, sans-serif;\n  }\n\n  &__btn {\n    min-width: 160px;\n    font-family: system-ui, -apple-system, sans-serif;\n  }\n}\n\n\n// Potential Tab Custom States\n.needs-computation-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 64px 32px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  text-align: center;\n  margin: 32px auto;\n  max-width: 600px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);\n\n  &__icon-wrapper {\n    width: 64px;\n    height: 64px;\n    border-radius: 32px;\n    background: #ffffff;\n    color: var(--explore-color, #0f3460);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 28px;\n    margin-bottom: 24px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  }\n\n  h2 {\n    font-size: 22px;\n    font-weight: 600;\n    color: var(--explore-color, #0f3460);\n    margin: 0 0 16px 0;\n  }\n\n  p {\n    font-size: 15px;\n    color: #475569;\n    max-width: 480px;\n    margin: 0 0 32px 0;\n    line-height: 1.6;\n  }\n}\n\n.computing-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 64px 32px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  text-align: center;\n  margin: 32px auto;\n  max-width: 600px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);\n\n  &__icon {\n    font-size: 36px;\n    color: var(--explore-color, #0f3460);\n    margin-bottom: 24px;\n  }\n\n  h2 {\n    font-size: 20px;\n    font-weight: 600;\n    color: var(--explore-color, #0f3460);\n    margin: 0 0 12px 0;\n  }\n\n  p {\n    font-size: 15px;\n    color: #475569;\n    margin: 0 0 40px 0;\n  }\n}\n\n.step-progress {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  width: 100%;\n  max-width: 600px;\n\n  &__item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n    position: relative;\n    flex: 1;\n\n    &::after {\n      content: '';\n      position: absolute;\n      top: 16px;\n      left: calc(50% + 24px);\n      width: calc(100% - 48px);\n      height: 2px;\n      background: var(--light-grey, #e8e8e8);\n      z-index: 0;\n    }\n\n    &:last-child::after {\n      display: none;\n    }\n  }\n\n  &__icon {\n    width: 32px;\n    height: 32px;\n    border-radius: 16px;\n    background: #fff;\n    border: 2px solid var(--light-grey, #e8e8e8);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    color: var(--text-3, #9ca3af);\n    z-index: 1;\n    transition: all 0.3s ease;\n\n    &--active {\n      border-color: var(--explore-color, #0f3460);\n      color: var(--explore-color, #0f3460);\n      background: #eff6ff;\n    }\n\n    &--done {\n      background: var(--explore-color, #0f3460);\n      border-color: var(--explore-color, #0f3460);\n      color: #fff;\n    }\n  }\n\n  &__label {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--text-3, #9ca3af);\n\n    &--active {\n      color: var(--text-1, #1a1a2e);\n    }\n  }\n}\n\n.data-status-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 16px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  margin-bottom: 16px;\n\n  &__left {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  &__dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: #10b981;\n    flex-shrink: 0;\n  }\n\n  &__icon--spinning {\n    font-size: 14px;\n    color: #3b82f6;\n  }\n\n  &__text {\n    font-size: 13px;\n    color: #475569;\n    font-family: system-ui, -apple-system, sans-serif;\n    font-weight: 500;\n  }\n\n  &__recompute {\n    font-size: 13px;\n    font-weight: 500;\n    color: #3b82f6;\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 0;\n    font-family: system-ui, -apple-system, sans-serif;\n\n    &:hover {\n      color: #2563eb;\n      text-decoration: underline;\n    }\n  }\n}\n\n.failed-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 64px 32px;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 12px;\n  text-align: center;\n  margin: 32px auto;\n  max-width: 600px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);\n\n  &__icon {\n    font-size: 36px;\n    color: #ef4444;\n    margin-bottom: 24px;\n    padding: 16px;\n    background: #ffffff;\n    border-radius: 50%;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  }\n\n  h2 {\n    font-size: 20px;\n    font-weight: 600;\n    color: #991b1b;\n    margin: 0 0 12px 0;\n  }\n\n  p {\n    font-size: 15px;\n    color: #b91c1c;\n    max-width: 480px;\n    margin: 0 0 32px 0;\n    line-height: 1.6;\n  }\n}\n\n.skeleton-checking {\n  padding: 40px;\n  margin-top: 24px;\n  border-radius: 12px;\n  border: 1px solid var(--light-grey, #e8e8e8);\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n\n  .shimmer-text {\n    height: 14px;\n    width: 200px;\n    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n    background-size: 200% 100%;\n    animation: shimmer 1.5s infinite;\n    border-radius: 4px;\n  }\n\n  .shimmer-box {\n    height: 200px;\n    width: 100%;\n    max-width: 600px;\n    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n    background-size: 200% 100%;\n    animation: shimmer 1.5s infinite;\n    border-radius: 8px;\n  }\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: 200% 0;\n  }\n\n  100% {\n    background-position: -200% 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tab-potential": `TabPotential_tab-potential__O1rgR`,
	"tab-potential__intro": `TabPotential_tab-potential__intro__KL8Dn`,
	"tab-potential__main-grid": `TabPotential_tab-potential__main-grid__qS6Pp`,
	"tab-potential__left-col": `TabPotential_tab-potential__left-col__QEezW`,
	"tab-potential__right-col": `TabPotential_tab-potential__right-col__uPM0T`,
	"kpi-row": `TabPotential_kpi-row__-pHzb`,
	"kpi-item": `TabPotential_kpi-item__J4Ivj`,
	"kpi-item__title": `TabPotential_kpi-item__title__9pPzU`,
	"kpi-item__value": `TabPotential_kpi-item__value__059Id`,
	"controls-bar": `TabPotential_controls-bar__QKtRZ`,
	"controls-bar__group": `TabPotential_controls-bar__group__4IPMg`,
	"signals": `TabPotential_signals__kqvyj`,
	"signal-card": `TabPotential_signal-card__+Kjfn`,
	"signal-card__title": `TabPotential_signal-card__title__oZYks`,
	"signal-card__text": `TabPotential_signal-card__text__lACK1`,
	"view-controls": `TabPotential_view-controls__N93VR`,
	"viewport": `TabPotential_viewport__hl+XP`,
	"card": `TabPotential_card__B7TBE`,
	"card__header": `TabPotential_card__header__f3z9U`,
	"placeholder-box": `TabPotential_placeholder-box__K6uW+`,
	"drawer-header": `TabPotential_drawer-header__l1TNo`,
	"drawer-header__main": `TabPotential_drawer-header__main__mHA1K`,
	"drawer-header__avatar": `TabPotential_drawer-header__avatar__xF3-s`,
	"drawer-header__info": `TabPotential_drawer-header__info__CqYLZ`,
	"compute-gate": `TabPotential_compute-gate__z1qm0`,
	"compute-gate__eyebrow": `TabPotential_compute-gate__eyebrow__1L+um`,
	"compute-gate__title": `TabPotential_compute-gate__title__jFgnc`,
	"compute-gate__desc": `TabPotential_compute-gate__desc__h0BJr`,
	"compute-gate__pills": `TabPotential_compute-gate__pills__XvasV`,
	"compute-gate__pill": `TabPotential_compute-gate__pill__sz+LX`,
	"compute-gate__filter-row": `TabPotential_compute-gate__filter-row__yMaxB`,
	"compute-gate__filter-label": `TabPotential_compute-gate__filter-label__+lltT`,
	"compute-gate__filter-tag": `TabPotential_compute-gate__filter-tag__UT8I0`,
	"compute-gate__btn": `TabPotential_compute-gate__btn__AdR-P`,
	"needs-computation-state": `TabPotential_needs-computation-state__Igs4W`,
	"needs-computation-state__icon-wrapper": `TabPotential_needs-computation-state__icon-wrapper__Q1sFn`,
	"computing-state": `TabPotential_computing-state__9dSMj`,
	"computing-state__icon": `TabPotential_computing-state__icon__7V9R9`,
	"step-progress": `TabPotential_step-progress__pcXa+`,
	"step-progress__item": `TabPotential_step-progress__item__O8dgg`,
	"step-progress__icon": `TabPotential_step-progress__icon__jGG2Y`,
	"step-progress__icon--active": `TabPotential_step-progress__icon--active__71bNi`,
	"step-progress__icon--done": `TabPotential_step-progress__icon--done__vJzdI`,
	"step-progress__label": `TabPotential_step-progress__label__fzs9I`,
	"step-progress__label--active": `TabPotential_step-progress__label--active__qu+xA`,
	"data-status-row": `TabPotential_data-status-row__de8VI`,
	"data-status-row__left": `TabPotential_data-status-row__left__nG6fC`,
	"data-status-row__dot": `TabPotential_data-status-row__dot__QrqRI`,
	"data-status-row__icon--spinning": `TabPotential_data-status-row__icon--spinning__Ufid1`,
	"data-status-row__text": `TabPotential_data-status-row__text__5WEQj`,
	"data-status-row__recompute": `TabPotential_data-status-row__recompute__wy2Zc`,
	"failed-state": `TabPotential_failed-state__+s5JW`,
	"failed-state__icon": `TabPotential_failed-state__icon__Uh5Oy`,
	"skeleton-checking": `TabPotential_skeleton-checking__IRCLi`,
	"shimmer-text": `TabPotential_shimmer-text__hUOvT`,
	"shimmer": `TabPotential_shimmer__lHeKB`,
	"shimmer-box": `TabPotential_shimmer-box__Bx0Q1`
};
export default ___CSS_LOADER_EXPORT___;
